// extracted by mini-css-extract-plugin
export default {"segmentedControl":"styles_segmentedControl__8SBam"};